import { MapPin, CheckCircle2, ArrowRight, FileText, ShieldCheck, Truck, Percent } from "lucide-react";
import Reveal from "@/components/Reveal";
import { STATES } from "@/constants/states";

const BENEFITS = [
  "Nationwide service across all 50 U.S. states",
  "Prepaid USPS shipping — just an $18 flat-rate fee",
  "Six-month repair warranty",
  "15% off first repair order",
  "High-speed, low-speed, electric, and surgical repairs",
  "Convenient mail-in repair process",
  "Professional service and communication",
];

export default function NationwidePromo() {
  return (
    <section className="relative overflow-hidden bg-abyss py-20 text-white sm:py-24" data-testid="nationwide-promo-section">
      <div className="blueprint-dark absolute inset-0 opacity-50" />
      <div className="pointer-events-none absolute -right-24 top-0 h-[380px] w-[380px] rounded-full bg-brandpink/10 blur-[120px]" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="eyebrow flex items-center gap-2 text-brandsky">
              <MapPin className="h-3.5 w-3.5" /> New — nationwide expansion
            </p>
            <h2 className="font-display mt-3 text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-[2.7rem] lg:leading-[1.05]" data-testid="nationwide-headline">
              Professional Dental Handpiece Repair — Now Serving All 50 States
            </h2>
            <p className="mt-5 max-w-xl text-[15.5px] leading-relaxed text-white/70" data-testid="nationwide-subheadline">
              JSL Dental Repair provides professional high-speed, low-speed, electric, and surgical handpiece repairs
              to dental offices nationwide. Ship your handpieces directly to our repair facility and let our team
              handle the rest.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="/nationwide-dental-handpiece-repair#label-form"
                data-testid="nationwide-cta-label"
                className="btn-lift inline-flex items-center gap-2.5 rounded-full bg-brandpink px-7 py-3.5 text-[14.5px] font-bold text-white shadow-[0_16px_36px_rgba(234,76,137,0.4)] hover:bg-brandpink-deep"
              >
                Request a Prepaid Shipping Label
              </a>
              <a
                href="/nationwide-dental-handpiece-repair#how-it-works"
                data-testid="nationwide-cta-how"
                className="btn-lift inline-flex items-center gap-2.5 rounded-full border border-white/25 px-7 py-3.5 text-[14.5px] font-bold text-white hover:border-white/60"
              >
                Learn How Mail-In Repairs Work
              </a>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal delay={0.1}>
            <ul className="grid gap-2.5 sm:grid-cols-2">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-2.5 rounded-xl border border-white/10 bg-white/[0.05] px-4 py-3 text-[13px] font-medium text-white/85 backdrop-blur" data-testid="nationwide-benefit">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brandleaf" />
                  {b}
                </li>
              ))}
            </ul>
            <div className="mt-5 flex flex-wrap items-center gap-2" data-testid="nationwide-states-strip">
              {["NY", "CA", "TX", "FL", "IL", "OH", "GA", "AZ", "PA", "NC"].map((s) => (
                <span key={s} className="font-mono rounded-lg border border-brandsky/40 bg-brandsky/10 px-2.5 py-1 text-[11px] font-bold text-brandsky">{s}</span>
              ))}
              <span className="text-[12px] font-semibold text-white/50">+ every other state</span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}